/**
 * If the modelId is a full Bedrock ARN (e.g., from a copied console URL),
 * this is likely an application inference profile ARN that's account-specific
 * and won't work across accounts. We can't simply swap the account ID because
 * the profile ID itself is tied to the original account.
 *
 * For cross-region inference profiles, the short-form model ID (e.g.,
 * `us.anthropic.claude-opus-4-6-v1`) works across any account with model access.
 *
 * This function extracts the account ID from an ARN for display purposes only.
 */
export function extractAccountFromArn(arn: string): string | null {
  if (!arn.startsWith('arn:')) return null
  const parts = arn.split(':')
  return parts.length >= 5 ? parts[4] : null
}

/**
 * Checks if a model ID is a full ARN (account-specific) rather than a
 * portable model identifier.
 */
export function isFullArn(modelId: string): boolean {
  return modelId.startsWith('arn:')
}
